// Kontextueller Förder-Hinweis für Insights-Artikel: verlinkt thematisch passende
// Ressourcen des Fördermittel-Finders (foerdermittel.daaniyalkhan.com).
// Artikel sind deutschsprachig, daher deutsche Copy ohne i18n.
const FoerderHinweis = ({ text, links }) => (
  <aside className="not-prose my-10 rounded-xl border border-[#C5A66A]/40 bg-[#C5A66A]/5 p-6">
    <p className="text-xs font-semibold uppercase tracking-wider text-[#C5A66A] mb-2">
      Förder-Tipp
    </p>
    <p className="text-gray-800 leading-relaxed">{text}</p>
    <p className="mt-3 flex flex-wrap gap-x-6 gap-y-2 text-sm font-semibold">
      {links.map((l) => (
        <a
          key={l.href}
          href={l.href}
          className="text-[#0F1B2D] underline decoration-[#C5A66A] underline-offset-4 hover:text-[#C5A66A] transition-colors"
        >
          {l.label} →
        </a>
      ))}
    </p>
  </aside>
);

export default FoerderHinweis;
